import React from 'react'

const Loading = () => {
    return (
        <div className="loading">
            Rooms are loading
        </div>
    )
}

export default Loading
